module.exports = __webpack_public_path__ + "static/ratflap_img_houses-0f73f84ab57ad37ac24a67aed7b5f2cf.jpg";